function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  fillRule: "nonzero",
  x: 0,
  y: 2,
  width: 56,
  height: 44
}), React.createElement("g", {
  id: "icon-reported2",
  transform: "translate(9.000000, 2.000000)",
  fill: "#0dcf5a",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M2.93508214,36.75 L2.93508214,5.25 C2.93508214,3.80165625 4.12238571,2.625 5.57793929,2.625 L32.0065107,2.625 C33.4647071,2.625 34.6493679,3.80165625 34.6493679,5.25 L34.6493679,20.6820469 L37.292225,18.0570469 L37.292225,5.25 C37.292225,2.3506875 34.9255464,0 32.0065107,0 L5.57793929,0 C2.65890357,0 0.292225,2.3506875 0.292225,5.25 L0.292225,36.75 C0.292225,39.6493125 2.65890357,42 5.57793929,42 L18.4621582,42 L18.792225,39.375 L5.57793929,39.375 C4.12238571,39.375 2.93508214,38.1983437 2.93508214,36.75 Z",
  id: "Path"
}), React.createElement("polygon", {
  id: "Path",
  points: "29.292225 8 8.292225 8 8.292225 11 29.292225 11"
}), React.createElement("polygon", {
  id: "Path",
  points: "29.292225 14 8.292225 14 8.292225 17 29.292225 17"
}), React.createElement("polygon", {
  id: "Path",
  points: "29.292225 20 8.292225 20 8.292225 23 29.292225 23"
}), React.createElement("polygon", {
  id: "Path",
  points: "8.292225 29 19.292225 29 19.292225 26 8.292225 26"
}), React.createElement("path", {
  d: "M42.4499366,23.875 L40.4173036,21.842375 C39.8555983,21.2806719 39.1203142,21 38.3846707,21 C37.6490272,21 36.9133837,21.2806719 36.3520377,21.842375 L24.0096145,34.18475 C23.4479092,34.7460937 21.7297306,36.9177969 21.7297306,37.6534375 L20.292225,44 L26.6373748,42.5625 C26.6373748,42.5625 29.5461674,40.8443281 30.1075133,40.282625 L42.4499366,27.94025 C43.5729878,26.8175625 43.5729878,24.9966094 42.4499366,23.875 Z M29.2139954,39.3205759 C29.0479101,39.4793318 28.4733941,39.8699453 27.7716561,40.32 L23.972225,36.4939814 C24.3619572,35.9560572 24.7956856,35.4151793 25.0636953,35.1471402 L34.5444913,25.6 L38.692225,29.7767585 L29.2139954,39.3205759 Z",
  id: "Shape"
})));

var SvgIconReported = function SvgIconReported(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "56px",
    height: "46px",
    viewBox: "0 0 56 46",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconReported, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-reported.56dee885.svg";
export { ForwardRef as ReactComponent };